/* eslint-disable @typescript-eslint/no-explicit-any */
import "./ConfirmScreenOneEntrega.css"

import { Descriptions, Image } from "antd"
import React, { useEffect, useState } from "react"

import { toCPF, toLicensePlate, toReadableBoolean, toReadableDate } from "../../../helpers/format"
import promisify from "../../../helpers/promisify"
import { type ApplicationState } from "../../../store"

interface OwnProps {
  formData: ApplicationState["onefleetentrega"]
}

const ConfirmScreenOneFleet = (props: OwnProps): React.ReactElement => {
  const {
    email,
    name,
    cpf,
    company,
    licensePlate,
    pickupDate,
    carKm,
    clientPhoneCountry,
    clientPhone,
    consultantName,
    consultantEmail,
    dealer,
    model,

    hasCarProblem,
    carProblemDescription,
    carProblemImages,
    cnhImages,
    licensePlateImages,
    clientPicture,
    clientSignatureImage

    // surveyGrade,
    // surveyDescription
  } = props.formData.data

  const [carProblemImagesURL, setCarProblemImagesURL] = useState<any[]>([])
  const [cnhImagesURL, setCnhImagesURL] = useState<any[]>([])
  const [licensePlateImagesURL, setLicensePlateImagesURL] = useState<any[]>([])
  const [clientPictureURL, setClientPictureURL] = useState<any>("")

  useEffect(() => {
    const formatImages = async () => {
      const tempCarProblemURL = carProblemImagesURL
      const tempCNHURL = cnhImagesURL
      const tempLicensePlateURL = licensePlateImagesURL

      if (carProblemImages) {
        for (const image of carProblemImages) {
          const base64 = await promisify.blobTo64(image.originFileObj as Blob)
          tempCarProblemURL.push({ key: image.uid, base64 })
          const unique = Array.from(new Map(tempCarProblemURL.map((m) => [m.key, m]))).map(value => value[1])
          setCarProblemImagesURL(unique)
        }
      }

      if (cnhImages) {
        for (const image of cnhImages) {
          const base64 = await promisify.blobTo64(image.originFileObj as Blob)
          tempCNHURL.push({ key: image.uid, base64 })
          const unique = Array.from(new Map(tempCNHURL.map((m) => [m.key, m]))).map(value => value[1])
          setCnhImagesURL(unique)
        }
      }

      if (licensePlateImages) {
        for (const image of licensePlateImages) {
          const base64 = await promisify.blobTo64(image.originFileObj as Blob)
          tempLicensePlateURL.push({ key: image.uid, base64 })
          const unique = Array.from(new Map(tempLicensePlateURL.map((m) => [m.key, m]))).map(value => value[1])
          setLicensePlateImagesURL(unique)
        }
      }

      if (clientPicture) {
        const base64 = await promisify.blobTo64(clientPicture.originFileObj as Blob)
        setClientPictureURL(base64)
      }
    }

    formatImages().catch(err => { console.warn(err) })
  }, [])

  return (
    <div className="onefleet-form-visualization">
      <Descriptions
        bordered
        size="small"
        column={{ xxl: 3, xl: 3, lg: 3, md: 3, sm: 3, xs: 3 }}
        layout="vertical"
      >
        <Descriptions.Item span={3} label="Nome do cliente">{name}</Descriptions.Item>
        <Descriptions.Item span={3} label="E-mail do cliente">{email}</Descriptions.Item>
        <Descriptions.Item span={1} label="CPF do cliente">{toCPF(cpf)}</Descriptions.Item>
        <Descriptions.Item span={2} label="Telefone do cliente">{`+${clientPhoneCountry?.code} ${clientPhone}`}</Descriptions.Item>
        <Descriptions.Item span={1} label="Empresa">{company}</Descriptions.Item>
        <Descriptions.Item span={1} label="Placa do veículo">{toLicensePlate(licensePlate)}</Descriptions.Item>
        <Descriptions.Item span={1} label="Data de retirada">{toReadableDate(pickupDate)}</Descriptions.Item>
        <Descriptions.Item span={1} label="Modelo do veículo">{model}</Descriptions.Item>
        <Descriptions.Item span={1} label="Km do veículo">{carKm}</Descriptions.Item>
        <Descriptions.Item span={1} label="Concessionária">{dealer}</Descriptions.Item>
        <Descriptions.Item span={3} label="Nome do consultor">{consultantName}</Descriptions.Item>
        <Descriptions.Item span={3} label="E-mail do consultor">{consultantEmail}</Descriptions.Item>
        <Descriptions.Item span={3} label="O veículo possui avarias ou itens faltantes?">{toReadableBoolean(hasCarProblem)}</Descriptions.Item>
        {/* <Descriptions.Item label="Nota do serviço" span={3}><Rate count={10} disabled={true} defaultValue={surveyGrade ?? 0}/></Descriptions.Item>
        <Descriptions.Item label="Comentários" span={3}>{surveyDescription}</Descriptions.Item> */}
        {cnhImagesURL.map(imageURL => <Descriptions.Item label="CNH" span={3} key={imageURL.key} ><Image src={imageURL.base64} /></Descriptions.Item>)}
        {licensePlateImagesURL.map(imageURL => <Descriptions.Item label="Placa do veículo" span={3} key={imageURL.key} ><Image src={imageURL.base64} /></Descriptions.Item>)}
        {
          hasCarProblem && (<>
            <Descriptions.Item label="Descrição da avaria ou item faltante" span={3}>{carProblemDescription}</Descriptions.Item>
            {carProblemImagesURL.map(imageURL => <Descriptions.Item label="Avaria ou item faltante" span={3} key={imageURL.key} ><Image src={imageURL.base64} /></Descriptions.Item>)}
          </>)
        }
        <Descriptions.Item span={3} label="Foto do cliente"><Image src={clientPictureURL} /></Descriptions.Item>
        <Descriptions.Item span={3} label="Assinatura do cliente"><Image src={clientSignatureImage} /></Descriptions.Item>
      </Descriptions>
    </div>
  )
}

export default ConfirmScreenOneFleet
